import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {URLSearchParams} from '@angular/http';
import {EnvironmentService} from './environment.service';

import {environment} from '../../../environments/environment';

@Injectable()
export class ApiService {
    protected baseUrl = '';

    protected httpOptions = {headers: new HttpHeaders()}

    constructor(private http: HttpClient) {
        this.baseUrl = environment.api_url;
    }


    createUrl(url: string) {
        if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) {
            return url;
        } else {
            return this.baseUrl.concat(url);
        }
    }

    createUrlWithParams(url: string, params?: object) {
        const queryParams = new URLSearchParams();
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                queryParams.set(key, params[key])
            }
        }
        return (params) ? this.createUrl(url).concat('?' + queryParams.toString()) : this.createUrl(url);
    }

    createParams(params){
        if(params) {
            const queryParams = new URLSearchParams();
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    queryParams.set(key, params[key])
                }
            }
            return '?' + queryParams.toString();
        }
        return '';
    }

    createUrlWithRoute(url: string, element: string) {
        if(element) {
            return this.createUrl(url).concat('/' + element);
        }
        return this.createUrl(url);
    }

    createOptions(headers?: Object): Object {
        let customHeader = this.httpOptions.headers;
        if (headers) {
            for (const key in headers) {
                if (headers.hasOwnProperty(key)) {
                    customHeader = customHeader.set(key, headers[key]);
                }
            }
        }
        return {headers: customHeader};
    }

    setToken(token: string) {
        this.httpOptions = {
            headers: new HttpHeaders(
                {
                    'X-API-TOKEN': token
                }
            )
        }
    }

    getHttp() {
        return this.http;
    }

    post(url: string, data: Object, header?: Object) {
        return this.http.post(this.createUrl(url), data, this.createOptions(header));
    }

    put(url: string, element: any,data : any, params?: Object,header?: Object) {
        return this.http.put(this.createUrlWithRoute(url, element)+this.createParams(params), data, this.createOptions(header));
    }

    patch(url: string, element: any,data : any, params?: Object,header?: Object){
        return this.http.patch(this.createUrlWithRoute(url, element)+this.createParams(params), data, this.createOptions(header));
    }

    get(url: string, params?: Object, header?: Object) {
        return this.http.get(this.createUrlWithParams(url, params), this.createOptions(header));
    }

    remove(url: string, element: any, params?: Object, header?: Object) {
        return this.http.delete(this.createUrlWithRoute(url, element)+this.createParams(params), this.createOptions(header));
    }

    customRemove(url: string, params?: Object, header?: Object) {
        return this.http.delete(this.createUrl(url) + this.createParams(params), this.createOptions(header));
    }

    customPut(url: string, data: Object, header?: Object) {
        return this.http.put(this.createUrl(url), data, this.createOptions(header));
    }

    customPatch(url: string, data: Object, header?: Object) {
        return this.http.patch(this.createUrl(url), data, this.createOptions(header));
    }



    //para formData con Progress Bar
    req(method,url,data){
        const req = new HttpRequest(method, this.createUrl(url), data, {
            reportProgress: true,
            headers: this.httpOptions.headers// for progress data
        });
        return this.http.request(req);
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/api.service.ts